"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var link_1 = require("spry-react/Link/link");
function RemoveLink(props) {
    return React.createElement(link_1.Link, { disabled: props.disabled, className: 'trash-icon link-gray', title: props.title, onClick: props.onClick },
        props.verb || 'Remove',
        " ",
        props.noun);
}
exports.RemoveLink = RemoveLink;
